import React from "react";
import './style.scss';
import { mtn_main_img } from "../../../assets/mtn";

export const MainImageSection = () => {
  return (
    <section className={'mainImageSection'}>
      <div className={'container'}></div>
      <picture>
        <img
          alt='main'
          src={mtn_main_img as string}
          width='100%'
          style={{ borderRadius: '24px' }}        />
      </picture>
      <p className={'shortDescription'}>Target known users with the only cookieless programmatic ad platform. Our patented AI matches anonymized telco subscriber profiles in real-time allowing you to find your target customer with ultimate precision</p>
    </section>
  );
};
